import { AnalyticsService } from '@hb/services/analytics/analytics.service';
import { ButtonKey, QuestionKey } from '@hb/modules/global/global.constants';

import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
    standalone: true,
    selector: '[analyticsClick]'
})
export class AnalyticsClickDirective {
    @Input() elementType: string;
    @Input() key: QuestionKey | ButtonKey;

    @HostListener('click') onClick(): void {
        this.sendAnalytics();
    }

    constructor(
        private readonly elementRef: ElementRef,
        private readonly analyticsService: AnalyticsService
    ) {}

    sendAnalytics(): void {
        this.analyticsService.sendClickUpdate(this.elementType, this.key);
    }
}
